import { Component, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ToastService } from '../services/toasts.service';
import { NgbToast, NgbToastHeader } from '@ng-bootstrap/ng-bootstrap';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgbToast, NgbToastHeader, NgTemplateOutlet]
})
export class ToastsComponent {
  Number = Number;

  constructor(public toastService: ToastService) {}
  
  isTemplate(toast : any) {
		return toast.textOrTpl instanceof TemplateRef;
	}
}
